var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feather Icons / search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16663 3.33366C5.94496 3.33366 3.33329 5.94533 3.33329 9.16699C3.33329 12.3887 5.94496 15.0003 9.16663 15.0003C12.3883 15.0003 15 12.3887 15 9.16699C15 5.94533 12.3883 3.33366 9.16663 3.33366ZM1.66663 9.16699C1.66663 5.02486 5.02449 1.66699 9.16663 1.66699C13.3088 1.66699 16.6666 5.02486 16.6666 9.16699C16.6666 13.3091 13.3088 16.667 9.16663 16.667C5.02449 16.667 1.66663 13.3091 1.66663 9.16699Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2857 13.2861C13.6111 12.9606 14.1388 12.9606 14.4642 13.2861L18.0892 16.9111C18.4147 17.2365 18.4147 17.7641 18.0892 18.0896C17.7638 18.415 17.2361 18.415 16.9107 18.0896L13.2857 14.4646C12.9603 14.1391 12.9603 13.6115 13.2857 13.2861Z",
    fill: "#101010"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlack);
export default __webpack_public_path__ + "static/media/search_black.528ab1a927e1d14b5073853eade5a2bd.svg";
export { ForwardRef as ReactComponent };